export const ADD_TO_CART = "ADD_TO_CART";
export const CHANGE_TO_CART = "CHANGE_TO_CART";
export const REMOVE_FROM_CART ="REMOVE_FROM_CART";
export const CART_RESET = "CART_RESET";



export const RECORD_ADD_TO_CART = "RECORD_ADD_TO_CART";
export const RECORD_ADD_TO_CART_FAIL = "RECORD_ADD_TO_CART_FAIL";






